module.exports = "/resources/assets/prod/f5f0732793f1138d9e768912cc30f4d5.svg";